<div>
  <h2 mat-dialog-title>Change wallet network</h2>
  <div mat-dialog-content>
    <p>Currently you are connected to {{ networks[data.currentNetId] ? networks[data.currentNetId] : 'unknown' }} network.</p>
    <p>Please swtich to your wallet to {{ data.expectedNetId ? networks[data.expectedNetId] : 'Ethereum Mainnet or Binance Smart Chain Mainnet'}}.</p>
  </div>
</div>
